import { render } from "./SshQuickCommand.vue?vue&type=template&id=65b7de20&scoped=true"
import script from "./SshQuickCommand.vue?vue&type=script&lang=js"
export * from "./SshQuickCommand.vue?vue&type=script&lang=js"

import "./SshQuickCommand.vue?vue&type=style&index=0&id=65b7de20&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SshQuickCommand.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "./SshQuickCommand.vue?vue&type=custom&index=1&blockType=i18n&locale=cn&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b7de20"]])

export default __exports__